import { useTranslate } from "ra-core";

import { MobileContent } from "../layout/MobileContent";
import { MobileListHeader } from "../layout/MobileListHeader";
import { Dashboard } from "./Dashboard";

/**
 * The phone dashboard: the fixed mobile page header plus exactly the same
 * <Dashboard> composition as the desktop. The dashboard pieces themselves are
 * responsive (stacked header, two tiles per row, a horizontally scrolling
 * funnel, stacked cards), so there is no second implementation here.
 */
export const MobileDashboard = () => {
  const translate = useTranslate();
  return (
    <>
      <MobileListHeader title={translate("ra.page.dashboard")} />
      <MobileContent>
        <Dashboard />
      </MobileContent>
    </>
  );
};
